var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCatalogCashAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 39,
  height: 39,
  fill: "none",
  viewBox: "0 0 39 39"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M21 1.5a1.5 1.5 0 0 0-3 0V18H1.5a1.5 1.5 0 0 0 0 3H18v16.5a1.5 1.5 0 0 0 3 0V21h16.5a1.5 1.5 0 0 0 0-3H21z",
  clipRule: "evenodd"
})));
export { SvgCatalogCashAdd as ReactComponent };